<!--车配严选采购单打印模板-->
<template>
    <div v-loading="loading">
        <div id="printContent" class="print-zone">
            <div v-for="(item, index) in printList" :key="index">
                <div class="print-title-view">
                    <div class="order-code">
                        <canvas id="canvas" class="qrcode-canvas" ref="canva"></canvas>
                        <img class="qrcode-image" :src="imgUrl" v-if="imgUrl" />
                    </div>
                    <div class="print-title">供应商采购单</div>
                    <div class="company">
                        <div>单号：{{ orderCode }}</div>
                        <div>单位：{{ company }}</div>
                    </div>
                </div>

                <div class="print-table-main">
                    <div class="div-table-row">
                        <div class="div-table-cell hhead" style="width: 20%">供应商名称</div>
                        <div class="div-table-cell hhead" style="width: 80%">{{ item.EntpCusName }}</div>
                    </div>
                    <div class="div-table-row">
                        <div class="div-table-cell hhead" style="width: 20%">入仓仓库</div>
                        <div class="div-table-cell hhead" style="width: 30%">{{item.InStorage}}</div>
                        <div class="div-table-cell hhead" style="width: 20%">提交时间</div>
                        <div class="div-table-cell hhead" style="width: 30%">{{item.ConfirmTime}}</div>
                    </div>
                    <div class="div-table-row">
                        <div class="div-table-cell" style="width: 6%">序号</div>
                        <div class="div-table-cell" style="width: 16%">汽配编码</div>
                        <div class="div-table-cell" style="width: 21%">配件名称</div>
                        <div class="div-table-cell" style="width: 20%">车型</div>
                        <div class="div-table-cell" style="width: 6%">数量</div>
                        <div class="div-table-cell" style="width: 6%">单位</div>
                        <div class="div-table-cell" style="width: 10%" v-show="!isHidePrice">采购价</div>
                        <div class="div-table-cell" style="width: 15%">仓位</div>
                        <div class="div-table-cell" style="width: 10%" v-if="!isHidePrice">备注</div>
                        <div class="div-table-cell" style="width: 20%" v-else>备注</div>

                    </div>
                    <div class="div-table-row" v-for="(AP, index) in item.DetailList" :key="index">
                        <div class="div-table-cell" style="width: 6%">{{ Number(index) + 1 }}</div>
                        <div class="div-table-cell-wrap" style="width: 16%;line-height: 1.5em;">{{ AP.APCode }}</div>
                        <div class="div-table-cell" style="width: 21%">{{ AP.GoodName }}</div>
                        <div class="div-table-cell" style="width: 20%">适用:{{ AP.AutoSerise }}</div>
                        <div class="div-table-cell" style="width: 6%">{{ AP.Count }}</div>
                        <div class="div-table-cell" style="width: 6%">{{ AP.Unit }}</div>
                        <div class="div-table-cell" style="width: 10%" v-show="!isHidePrice">{{ AP.Price }}</div>
                        <div class="div-table-cell" style="width: 15%">{{ AP.GoodsLocation }}</div>
                        <div class="div-table-cell" style="width: 10%" v-if="!isHidePrice">{{ AP.Remark }}</div>
                        <div class="div-table-cell" style="width: 20%" v-else>{{ AP.Remark }}</div>

                    </div>
                    <div class="div-table-row">
                        <div class="div-table-cell" style="width: 6%"></div>
                        <div class="div-table-cell" style="width: 16%"></div>
                        <div class="div-table-cell" style="width: 21%"></div>
                        <div class="div-table-cell" style="width: 20%">总数量</div>
                        <div class="div-table-cell" style="width: 6%">{{ allNum }}</div>
                        <div class="div-table-cell" style="width: 6%">{{!isHidePrice?"总价":""}}</div>
                        <div class="div-table-cell" style="width: 10%" v-show="!isHidePrice">{{ allPrice }}</div>
                        <div class="div-table-cell" style="width: 15%" v-if="!isHidePrice"></div>
                        <div class="div-table-cell print-css" style="width: 15%" v-else></div>
                        <div class="div-table-cell" style="width: 10%" v-if="!isHidePrice"></div>
                        <div class="div-table-cell print-css" style="width: 20%" v-else></div>
                    </div>
                </div>
                <div class="order-remark">
                    <div>{{ item.Remark ? '备注：' + item.Remark : '' }}</div>
                </div>
            </div>
        </div>
        <div class="dialog-footer">
            <div class="btn-ctn-left">
                <div class="sort-set">
                    <el-button class="btn-primary" @click="hidePrice()">{{ isHidePrice?'展示价格信息':'隐藏价格信息' }} </el-button>
                </div>
            </div>
            <div class="re-submit">
                <el-button class="btn-primary" @click="lodopPrint" v-if="!isDefaultSet">打印</el-button>
                <el-button class="btn-primary" @click="printedRecord" v-print="'#printContent'" v-else>打印</el-button>
                <el-button @click="cancel()">关闭</el-button>
            </div>
        </div>
    </div>
</template>
<script>
import html2canvas from 'html2canvas';
import QRCode from 'qrcode';
export default {
    name: '',
    components: {},
    props: {
        isInit: {
            default: true,
            type: Boolean
        },
        printIds: {
            type: Array
        }
    },
    data() {
        return {
            loading: true,
            allPrice: 0,
            allNum: 0,
            printList: [],
            company: this.$util.getLocalStorage('userMsg').EntpName,
            orderCode: '',
            dataList: [],
            imgUrl: '',
            isPrint: false,
            isPreview: false,
            isDefaultSet: false,
            isHidePrice: false,
        };
    },
    created() {},
    mounted() {
        if (this.isInit) {
            this.init();
        } else this.loading = false;
    },
    watch: {
        orderCode(value) {
            this.$nextTick(function () {
                try {
                    let canvas = this.$refs.canva[0];
                    QRCode.toCanvas(
                        canvas,
                        value,
                        {
                            width: 80,
                            height: 80,
                            margin: 0,
                            scrollX: 0,
                            scrollY: 0
                        },
                        function (error) {}
                    );

                    setTimeout(() => {
                        html2canvas(canvas, {
                            width: 80,
                            height: 80,
                            scrollX: 0,
                            scrollY: 0
                        }).then(canvasRes => {
                            var imgData = canvasRes.toDataURL('image/png');
                            this.imgUrl = imgData;
                            canvas.style.display = 'none';
                        });
                    }, 1000);
                } catch (e) {
                    //
                }
            });
        }
    },
    methods: {
        init() {
            this.printList = [];
            this.dataList = [];
            this.getConfigByCodes().then(() => {
                this.getOrder();
            });
        },
        getConfigByCodes() {
            return new Promise(resolve => {
                let codes = ['dyyl', 'syllqdysz'];
                this.$util.getSysConfigs(codes).then(data => {
                    if (data) {
                        for (let i = 0; i < data.length; i++) {
                            let code = data[i].Code;
                            let result = data[i].Result;
                            switch (code) {
                                case 'dyyl':
                                    this.isPreview = result;
                                    break;
                                case 'syllqdysz':
                                    this.isDefaultSet = result;
                                    break;
                            }
                        }
                    }
                    resolve();
                });
            });
        },
        lodopPrint() {
            let LODOP = this.$lodop.getLodop(); //调用getLodop获取LODOP对象
            if (LODOP) {
                this.loading = true;
                let strBodyStyle = `<head><meta charset="utf-8" /><style>
                        .print-title-view {
                            width: 762px;
                            position: relative;
                            display: flex;
                            justify-content: space-between;
                            align-items: flex-end;
                            padding: 12px 0;
                        }
                        .order-code {
                            width: 80px;
                            height: 80px;
                            display: inline-block;
                            vertical-align: top;
                        }
                        .qrcode-canvas,
                        .qrcode-image {
                            display: none;
                        }
                        .btn-ctn-left {
                            display: flex;
                        }
                        .order-detail {
                            color: #000;
                        }
                        .order-remark {
                            display: -webkit-flex;
                            display: flex;
                            flex-direction: row;
                            justify-content: space-between;
                            margin-left: 10px;
                            margin-right: 10px;
                            padding: 0px 0px 15px 0px;
                            color: #000;
                        }
                        .company {
                            color: #000;
                        }
                        .print-title {
                            position: absolute;
                            top: 50%;
                            left: 50%;
                            transform: translate(-50%, -50%);
                            text-align: center;
                            font-size: 20px;
                            font-weight: bold;
                            color: #000;
                        }
                        .print-table-main {
                            width: 762px;
                            font-size: 14px;
                        }
                        .div-table-cell {
                            overflow: hidden;
                            text-overflow: ellipsis;
                            white-space: nowrap;
                            height: auto;
                            line-height: 30px;
                            padding-left: 10px;
                            border-top: 1px solid #000;
                            border-right: 1px solid #000;
                            border-bottom: 1px solid #000;
                            color: #000;
                        }
                        .div-table-cell-wrap {
                            white-space: pre-wrap;
                            overflow-wrap: break-word;
                            word-break: break-all;
                            height: auto;
                            line-height: 30px;
                            padding-left: 10px;
                            border-top: 1px solid #000;
                            border-right: 1px solid #000;
                            border-bottom: 1px solid #000;
                            color: #000;
                        }                           
                        .div-table-row {
                            display: flex;
                            border-left: 1px solid #000;
                            margin: 0;
                            font-size: 14px;
                        }
                        .hhead {
                            padding-left: 0px;
                            text-indent: 10px;
                        }
                        .hhead:first-of-type{
                            padding-left: 1px;
                        }  
                        .dialog-footer {
                            display: -webkit-flex;
                            display: flex;
                            flex-direction: row;
                            justify-content: space-between;
                            margin-top: 20px;
                        }
                        .sort-set {
                            margin-left: 10px;
                        }
                        .re-submit {
                            text-align: right;
                        }
                        .print-css{
                            width:28%;
                        }
                    </style></head>`;

                let strPrintHtml = '<!DOCTYPE html><html>' + strBodyStyle + '<body>' + document.getElementById('printContent').innerHTML + '</body></html>';

                LODOP.ADD_PRINT_BARCODE(10, 1, 100, 100, 'QRCode', this.orderCode);
                LODOP.SET_PRINT_STYLEA(0, 'QRCodeVersion', 3);
                LODOP.SET_PRINT_STYLEA(0, 'QRCodeErrorLevel', 'L');
                let contentHeight = document.getElementById('printContent').clientHeight;
                if (contentHeight <= 1080) {
                    LODOP.SET_PRINT_PAGESIZE(3, '210mm', '20mm', ''); // 这里3表示纵向打印且纸高“按内容的高度”；580表示纸宽58mm；45表示页底空白4.5mm
                    // top,left,width,height,htmlContent
                    LODOP.ADD_PRINT_HTM('0', '0', '210mm', '100%', strPrintHtml);
                } else {
                    LODOP.SET_PRINT_PAGESIZE(0, '210mm', '286mm', '');
                    // top,left,width,height,htmlContent
                    LODOP.ADD_PRINT_HTM('0', '0', '210mm', '100%', strPrintHtml);
                    LODOP.NEWPAGEA();
                }

                // //设计
                // LODOP.PRINT_DESIGN();
                //选择操作系统中设为“默认”的打印机，“-1”代表默认打印机
                LODOP.SET_PRINTER_INDEX(-1);

                if (this.isPreview) LODOP.PREVIEW();
                //预览
                else LODOP.PRINT(); // 直接打印

                setTimeout(() => {
                    this.printedRecord();
                }, 1000);
            }
        },
        cancel() {
            this.$emit('closeDialog', this.isPrint);
        },
        printedRecord() {
            this.loading = true;
            this.$util
                .printedRecord({ OrderId: this.printIds[0].id, Type: 2 }, false)
                .then(() => {
                    this.isPrint = true;
                    this.loading = false;
                    if (!this.isInit) this.$emit('closeDialog', true);
                })
                .catch(() => {
                    this.loading = false;
                });
        },
        hidePrice(){
            this.isHidePrice = !this.isHidePrice;
        },
        getOrder() {
            this.loading = true;
            this.$util
                .axiosGet({
                    url: '/api/EntpPurchaseOrder/GetEntpPurchaseOrderPrint',
                    data: {
                        EntpCusPOId: this.printIds[0].id
                    },
                    hideLoading: this.isInit
                })
                .then(res => {
                    let _allNum = 0;
                    let _allPrice = 0;
                    let data = res.data;
                    let DetailList = data.DetailList;
                    this.dataList = data.DetailList;
                    for (let i = 0; i < DetailList.length; i++) {
                        _allNum += Number(DetailList[i].Count);
                        _allPrice += DetailList[i].Count * DetailList[i].Price;
                    }
                    this.allNum = _allNum;
                    this.allPrice = _allPrice.toFixed(2) * 1;
                    this.printList.push(res.data);
                    this.orderCode = this.printIds[0].orderCode;
                    let that = this;
                    if (that.isInit) that.loading = false;
                    else {
                        this.$nextTick(() => {
                            setTimeout(() => {
                                that.lodopPrint();
                            }, 100);
                        });
                    }
                })
                .catch(() => {
                    this.loading = false;
                });
        }
    }
};
</script>
<style lang="less" scoped>
.print-title-view {
    width: 100%;
    position: relative;
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
    padding: 12px 0;
    .qrcode-canvas,
    .qrcode-image {
        width: 80px;
        height: 80px;
        display: inline-block;
        vertical-align: top;
    }
}
.order-detail {
    color: #000;
}
.order-remark {
    display: -webkit-flex;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    margin-left: 10px;
    margin-right: 10px;
    padding: 0px 0px 15px 0px;
    color: #000;
}
.company {
    color: #000;
}
.btn-ctn-left {
    display: flex;
}
.sort-set {
    margin-left: 10px;
    .btn-primary {
        background: #8c98cc;
        color: white;
        margin-left: 0px;
    }
}
.re-submit {
    text-align: right;
}
.print-title {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    text-align: center;
    font-size: 20px;
    font-weight: bold;
    color: #000;
}
.dialog-footer {
    display: -webkit-flex;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    margin-top: 20px;
}
.print-zone {
    width: 210mm;
}
.print-table-main {
    width: 792px;
    margin-bottom: 20px;
    font-size: 12px;
    .div-table-row {
        border-color: black;
        margin-left: 0;
    }
    .div-table-cell {
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        height: auto;
        line-height: 30px;
        padding-left: 10px;
        border-top: 1px solid #000;
        border-right: 1px solid #000;
        border-bottom: 1px solid #000;
        color: #000;
    }
    .div-table-cell-wrap {
        white-space: pre-wrap;
        overflow-wrap: break-word;
        word-break: break-all;
        height: auto;
        line-height: 30px;
        padding-left: 10px;
        border-top: 1px solid #000;
        border-right: 1px solid #000;
        border-bottom: 1px solid #000;
        color: #000;
    }    
    .hhead {
        padding-left: 0px;
        text-indent: 10px;
    }
    .hhead:first-of-type {
        padding-left: 1px;
    }
}
</style>
